export const UnitSuperType = 'Unit';
export var UnitType;
(function (UnitType) {
    UnitType[UnitType["Hero"] = 0] = "Hero";
    UnitType[UnitType["Infantry"] = 1] = "Infantry";
    UnitType[UnitType["Cavalry"] = 2] = "Cavalry";
    UnitType[UnitType["Beast"] = 3] = "Beast";
    UnitType[UnitType["Monster"] = 4] = "Monster";
    UnitType[UnitType["WarMachine"] = 5] = "WarMachine";
    UnitType[UnitType["Manifestation"] = 6] = "Manifestation";
    UnitType[UnitType["Terrain"] = 7] = "Terrain";
    UnitType[UnitType["Unknown"] = 99] = "Unknown";
})(UnitType || (UnitType = {}));
export function strToUnitType(str) {
    const upper = str.toUpperCase();
    if (upper === 'FACTION TERRAIN') {
        return UnitType.Terrain;
    }
    else if (upper === 'MANIFESTATION' || upper === 'ENDLESS SPELL') {
        return UnitType.Manifestation;
    }
    else if (upper === 'HERO') {
        return UnitType.Hero;
    }
    else if (upper === 'INFANTRY') {
        return UnitType.Infantry;
    }
    else if (upper === 'CAVALRY') {
        return UnitType.Cavalry;
    }
    else if (upper === 'BEAST') {
        return UnitType.Beast;
    }
    else if (upper === 'MONSTER') {
        return UnitType.Monster;
    }
    else if (upper === 'WAR MACHINE') {
        return UnitType.WarMachine;
    }
    return UnitType.Unknown;
}
export const unitTypeToString = (unit) => {
    if (unit.type === 0)
        return 'Hero';
    if (unit.type == 1)
        return 'Infantry';
    if (unit.type == 2)
        return 'Cavalry';
    if (unit.type == 3)
        return 'Beast';
    if (unit.type == 4)
        return 'Monster';
    if (unit.type == 5)
        return 'War Machine';
    if (unit.type == 6)
        return 'Manifestation';
    if (unit.type == 7)
        return 'Faction Terrain';
    return 'Regiment of Renown';
};
